import Icon from "hardcover-ui/components/Icon";
import BookPromptGroup from "components/BookGroup/groups/BookPromptGroup";
import Divider from "components/ui/Divider";
import { promptLink } from "constants/ExploreLinks";
import Heading from "hardcover-ui/components/Heading";
import TextLink from "hardcover-ui/components/TextLink";
import { PageSerializersUsersShowPublic, PromptSerializersPrompt } from "types/serializers";

export default function PinnedPrompts({
  user,
  prompts,
}: {
  user: PageSerializersUsersShowPublic;
  prompts: PromptSerializersPrompt[];
}) {
  if (prompts.length === 0) {
    return <></>;
  }

  return (
    <section>
      <div className="flex flex-row justify-between items-baseline">
        <Heading level={2} size="md">
          <Icon icon={promptLink.iconDuo} size="md" className="mr-2" />
          <span>{user.name}'s Pinned Prompts</span>
        </Heading>
        <TextLink
          variant="secondary"
          underline={false}
          href={`/@${user.username}/prompts/answered`}
          className="hidden lg:block"
        >
          See Answered Prompts
        </TextLink>
      </div>

      <div className="mt-8">
        {prompts.map((prompt) => (
          <div key={`book-prompt-${prompt.id}`} className="pt-4 space-y-8">
            <BookPromptGroup
              prompt={prompt}
              size="lg"
              context={{
                hidePosition: true,
                link: `/@${user.username}/prompts/${prompt.slug}`,
                referrerId: user.id,
              }}
            />
            <Divider />
          </div>
        ))}
      </div>
    </section>
  );
}
